import React, { useEffect } from 'react';
import './index.less';
// import IsMobilePartner from './isMobile';
import PuiSlider from './isMobile';

const PagePartner = props => {
  const { anchor, current, BubbleMachine } = props;
  const graphVW = anchor.isMobile ? 1.52 : 0.9635;


  useEffect(() => {
    const firstLi = document.getElementsByClassName('firstLi');
    // console.log("firstLi",firstLi);

    if (current == 4 && firstLi) {
      for (let index = 0; index < firstLi.length; index++) {
        const item = firstLi[index];
        item.style.opacity = 1;
        item.style.transform = "translateX(0px) translateY(0px)";
      }
    } else {
      for (let index = 0; index < firstLi.length; index++) {
        const item = firstLi[index];
        if (index / 2 == 0) {
          item.style.opacity = 0;
          item.style.transform = "translateX(200px) translateY(150px)";
        } else {
          item.style.opacity = 0;
          item.style.transform = "translateX(-200px) translateY(150px)";
        }

      }
    }
  }, [current])
  useEffect(() => {
    const secondLi = document.getElementsByClassName('secondLi');

    if (current == 4 && secondLi) {
      for (let index = 0; index < secondLi.length; index++) {
        const item = secondLi[index];
        item.style.opacity = 1;
        item.style.transform = "translateX(0px) translateY(0px)";
      }
    } else {
      for (let index = 0; index < secondLi.length; index++) {
        const item = secondLi[index];
        if (index < 3) {
          item.style.opacity = 0;
          item.style.transform = "translateX(200px) translateY(150px)";
        } else if (index > 3) {
          item.style.opacity = 0;
          item.style.transform = "translateX(-200px) translateY(150px)";
        } else if (index == 3) {
          item.style.opacity = 0;
          item.style.transform = "translateX(0px) translateY(150px)";
        }

      }
    }
  }, [current])
  useEffect(() => {
    const thirdLi = document.getElementsByClassName('thirdLi');

    if (current == 4 && thirdLi) {
      for (let index = 0; index < thirdLi.length; index++) {
        const item = thirdLi[index];
        item.style.opacity = 1;
        item.style.transform = "translateX(0px) translateY(0px)";
      }
    } else {
      for (let index = 0; index < thirdLi.length; index++) {
        const item = thirdLi[index];
        if (index == 0 || index == 1) {
          item.style.opacity = 0;
          item.style.transform = "translateX(200px) translateY(150px)";
        } else if (index == 2 || index == 3) {
          item.style.opacity = 0;
          item.style.transform = "translateX(-200px) translateY(150px)";
        }

      }
    }
  }, [current])
  useEffect(() => {
    const fourLi = document.getElementsByClassName('fourLi');

    if (current == 4 && fourLi) {
      for (let index = 0; index < fourLi.length; index++) {
        const item = fourLi[index];
        item.style.opacity = 1;
        item.style.transform = "translateX(0px) translateY(0px)";
      }
    } else {
      for (let index = 0; index < fourLi.length; index++) {
        const item = fourLi[index];
        if (index == 0) {
          item.style.opacity = 0;
          item.style.transform = "translateX(200px) translateY(150px)";
        } else if (index == 1) {
          item.style.opacity = 0;
          item.style.transform = "translateX(0px) translateY(150px)";
        } else if (index == 2) {
          item.style.opacity = 0;
          item.style.transform = "translateX(-200px) translateY(150px)";
        }

      }
    }
  }, [current])
  useEffect(() => {
    const fiveLi = document.getElementsByClassName('fiveLi');

    if (current == 4 && fiveLi) {
      for (let index = 0; index < fiveLi.length; index++) {
        const item = fiveLi[index];
        item.style.opacity = 1;
        item.style.transform = "translateX(0px) translateY(0px)";
      }
    } else {
      for (let index = 0; index < fiveLi.length; index++) {
        const item = fiveLi[index];
        if (index == 0) {
          item.style.opacity = 0;
          item.style.transform = "translateX(200px) translateY(150px)";
        } else if (index == 1) {
          item.style.opacity = 0;
          item.style.transform = "translateX(-200px) translateY(150px)";
        }
      }
    }
  }, [current])
  useEffect(() => {
    const sixLi = document.getElementsByClassName('sixLi');

    if (current == 4 && sixLi) {
      for (let index = 0; index < sixLi.length; index++) {
        const item = sixLi[index];
        item.style.opacity = 1;
        item.style.transform = "translateX(0px) translateY(0px)";
      }
    } else {
      for (let index = 0; index < sixLi.length; index++) {
        const item = sixLi[index];
        if (index == 0) {
          item.style.opacity = 0;
          item.style.transform = "translateX(0px) translateY(150px)";
        }
      }
    }
  }, [current])


  return (
    <div className='pagePartner' style={{ position: 'relative' }}>
      <div className="partner_title">
        合作伙伴
        </div>
      {
        anchor.isMobile
          ?
          <div style={{ position: 'absolute', top: "50%", marginTop: "-150px" }}>
            {/* <IsMobilePartner /> */}
            <div className="wrap" id="wrap">
              <PuiSlider />
            </div>

          </div>
          :
          <div className="partner_contents">
            <ul className='first'>
              <li className="firstLi">
                <div className='box'>
                  <div className='box_img'>
                    <img src='/assets/1.png' />
                  </div>
                </div>
              </li>
              <li className="firstLi">
                <div className='box'>
                  <div className='box_img'>
                    <img src='/assets/2.png' />
                  </div>
                </div>
              </li>
            </ul>
            <ul className='second'>
              <li className='secondLi'>
                <div className='box'>
                  <div className='box_img'>
                    <img src='/assets/3.png' />
                  </div>
                </div>
              </li>
              <li className='secondLi'>
                <div className='box'>
                  <div className='box_img'>
                    <img src='/assets/4.png' />
                  </div>
                </div>
              </li>
              <li className='secondLi'>
                <div className='box'>
                  <div className='box_img'>
                    <img src='/assets/5.png' />
                  </div>
                </div>
              </li>
              <li className='secondLi'>
                <div className='box'>
                  <div className='box_img'>
                    <img src='/assets/6.png' />
                  </div>
                </div>
              </li>
              <li className='secondLi'>
                <div className='box'>
                  <div className='box_img'>
                    <img src='/assets/7.png' />
                  </div>
                </div>
              </li>

            </ul>
            <ul className='third'>
              <li className='thirdLi'>
                <div className='box'>
                  <div className='box_img'>
                    <img src='/assets/8.png' />
                  </div>
                </div>
              </li>
              <li className='thirdLi'>
                <div className='box'>
                  <div className='box_img'>
                    <img src='/assets/9.png' />
                  </div>
                </div>
              </li>
              <li className='thirdLi'>
                <div className='box'>
                  <div className='box_img'>
                    <img src='/assets/10.png' />
                  </div>
                </div>
              </li>
              <li className='thirdLi'>
                <div className='box'>
                  <div className='box_img'>
                    <img src='/assets/11.png' />
                  </div>
                </div>
              </li>

            </ul>
            <ul className='four'>
              <li className="fourLi">
                <div className='box'>
                  <div className='box_img'>
                    <img src='/assets/12.png' />
                  </div>
                </div>
              </li>
              <li className="fourLi">
                <div className='box'>
                  <div className='box_img'>
                    <img src='/assets/13.png' />
                  </div>
                </div>
              </li>
              <li className="fourLi">
                <div className='box'>
                  <div className='box_img'>
                    <img src='/assets/14.png' />
                  </div>
                </div>
              </li>

            </ul>
            <ul className='five'>
              <li className='fiveLi'>
                <div className='box'>
                  <div className='box_img'>
                    <img src='/assets/15.png' />
                  </div>
                </div>
              </li>
              <li className='fiveLi'>
                <div className='box'>
                  <div className='box_img'>
                    <img src='/assets/16.png' />
                  </div>
                </div>
              </li>
            </ul>
            <ul className='six'>
              <li className="sixLi">
                <div className='box'>
                  <div className='box_img'>
                    <img src='/assets/17.png' />
                  </div>
                </div>
              </li>
            </ul>
          </div>
      }
      <div className='bubble'>
        {
          current == 4 && <BubbleMachine anchor={anchor} vw={graphVW} bgColor='#e8f4ff' />
        }
      </div>

      {
        !!anchor.isMobile
        &&
        <img
          src='/assets/top_text_6.png'
          className='top_text_6'
          style={{ width: `${anchor.scale * 26}px`, bottom: "10%", minWidth: 16 }}
        />
      }
    </div>
  )
}

export default PagePartner;